/**
 * Verifica o tamanho do titulo da pagina e caso seja maior 
 * que 80 caracteres corta o texto retornando o novo valor.
 * @param {*} reportConfigTitle: titulo da página
 */
const MAXIMUM_PAGE_TITLE_SIZE = 80;

export const slicePageTitle = (reportConfigTitle) => {
  if (reportConfigTitle && reportConfigTitle.length > MAXIMUM_PAGE_TITLE_SIZE) {
    const slicedTitle = reportConfigTitle.slice(0, MAXIMUM_PAGE_TITLE_SIZE)
    return slicedTitle;
  }
  return reportConfigTitle;
}